export default __webpack_public_path__ + "static/media/banner1.595d28c9.jpg";